import { mapDTO } from '@twistezo/ts-dto-mapper'

import { DomainUnfilledRecovery } from '../../types/domainUnfilledRecovery'
import { DomainUnfilledRecoveryDTO } from '../types/domainUnfilledRecoveryDTO'

type From = DomainUnfilledRecoveryDTO
type To = DomainUnfilledRecovery

export const domainUnfilledRecoveryFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((from: From): To => {
    const { baseAdUnitPath, prebidBehaviourType, prebidSettingsWarnings } = from
    return {
      baseAdUnitPath: baseAdUnitPath ?? undefined,
      prebidBehaviourType,
      prebidSettingsWarnings,
    }
  })
